import React, { useState, useEffect } from 'react';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import { API } from '../../../API/API';
import PageHeader from '../../../components/PageHeader/PageHeader';

const CertificateReport = (props) => {
    //Дата оноох функц
    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);

    //Багана оноох функц
    const [columns] = useState([{
        name: 'Ажилтны овог',
        fieldName: 'emplastname',
        colSize: 'small'
    }, {
        name: 'Ажилтны нэр',
        fieldName: 'empfirstname',
        minColSize: 'mid'
    }, {
        name: 'Дотоод нэгж',
        fieldName: 'departmentname',
    }, {
        name: 'Ажлын байр',
        fieldName: 'positionname',
    }, {
        name: 'Гэрчилгээ',
        fieldName: 'certificatename',
    }, {
        name: 'Гэрчилгээний дугаар',
        fieldName: 'certificateno'
    }, {
        name: 'Эхлэх огноо',
        fieldName: 'certificatedate',
    }, {
        name: 'Дуусах огноо',
        fieldName: 'expirydate',
    }, {
        name: 'Хүйс',
        fieldName: 'empgendername'
    }]);

    //Loading screen-ны функц
    const [loading, setLoading] = useState(false);

    //Дата оноож байгаа функц
    const getData = async () => {
        setLoading(true);
        let tData = [];

        await API.get('/api/humanresource/report/get_emp_certificate_report').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                tData = response.data.retdata;
            }
        });

        setData(tData);
        setOData(tData);
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, []);

    const onSearch = (p_data) => {
        setData(p_data);
    }

    //Утга буцаах функц
    return (
        <div>
            <PageHeader
                title='Гэрчилгээ'
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                loading={loading}
            />
            <GridDefaultShimmer
                data={data}
                columns={columns}
                loading={loading}
            />
        </div>
    );
}

export default CertificateReport;